import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowLeft.svg",
  "use": "arrowLeft.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"arrowLeft.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.20711 12.5L15.8536 5.85355C16.0488 5.65829 16.0488 5.34171 15.8536 5.14645C15.6583 4.95118 15.3417 4.95118 15.1464 5.14645L8.14645 12.1464C7.95118 12.3417 7.95118 12.6583 8.14645 12.8536L15.1464 19.8536C15.3417 20.0488 15.6583 20.0488 15.8536 19.8536C16.0488 19.6583 16.0488 19.3417 15.8536 19.1464L9.20711 12.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol